import { Injectable, inject } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Subject} from 'rxjs';
import {Location} from '@angular/common';
import {AuthService} from './auth.service';
import {Logger} from "../utils/logger";

@Injectable({
  providedIn: 'root'
})
export class CustomTokenSigninGuardService implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  private location = inject(Location);


  public loader$ = new Subject<boolean>();

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    Logger.log('canActivate CustomTokenSigninGuardService 1 ', route, state)
    const token = route.queryParams.sit;
    if (!token) {
      return Promise.resolve(true);
    }
    return new Promise<boolean | UrlTree>(async (resolve, reject) => {
      await this.authService.signOut()
      await this.authService.loginWithCustomToken(token.trim());

      let url = decodeURIComponent(state.url);
      url = url.substring(0, url.indexOf('?'));
      this.location.go(url);
      window.location.reload();
      return false;
    });
  }

}
